import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';

var tableId = 'tableGameBuildConfigurations';
var basketTableId = 'tableBasket';
var buildSelectorTableId = 'tableBuildSelector';
var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

var hashTypes = ["MD5", "SHA1", "SHA256"];

var COLUMN_INDEX = {
    GameCode: 1,
    Operation: 2,
    GameStatus: 3
}

var selectedType: string;
var FILTER_DELIM = '-delim-';
var selectedName: string;

export interface IndexPageOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    urlPost: string;
    urlRemove: string;
	urlClear: string;
	defaultHashButton: string;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
    }
}

export class IndexPage extends PageBase<IndexPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;

    private _btnShowMd5: JQuery;
    private _btnShowSha1: JQuery;
    private _btnShowSha256: JQuery;

    private _btnSelectBuild: JQuery;
    private _btnAddToBasketMulti: JQuery;

    private _chckAllBuilds: JQuery;

    private _form: JQuery;
    private _btnCancelSearch: JQuery;
    private _filterGame: MultiSelectApi;
    private _filterOperation: MultiSelectApi;
    private _filterGameStatus: MultiSelectApi;

    constructor(options: IndexPageOptions) {
        super(options);
		selectedType = options.defaultHashButton;
        this.showMd5 = this.showMd5.bind(this);
        this.showSha1 = this.showSha1.bind(this);
        this.showSha256 = this.showSha256.bind(this);
        this.drawCallback = this.drawCallback.bind(this);
        this.addToBasket = this.addToBasket.bind(this);
        this.formSubmit = this.formSubmit.bind(this);
        this.cancelSearch = this.cancelSearch.bind(this);
        this.preDrawCallback = this.preDrawCallback.bind(this);
        this.detectSelectedGame = this.detectSelectedGame.bind(this);
        this.showBuildSelector = this.showBuildSelector.bind(this);
        this.checkBoxAll = this.checkBoxAll.bind(this);
        this.displayHash = this.displayHash.bind(this);

        window['detectSelectedGame'] = this.detectSelectedGame;
        window['setBuildsSelectAllCheckbox'] = this.setBuildsSelectAllCheckbox;

        // === prepare table options
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Id',
            order: [1, "asc"],
            autoWidth: true,
            pageLength: 100,
            lengthMenu: [[50, 100, 200, 500, 1000], [50, 100, 200, 500, 1000]],
            columns: [
                {
                    sortable: false,
                    render: (data: any, type: any, rowData: any) => {
                        return (`<input id='chckbx${rowData.Id}' name='selectedBuild' value='${rowData.Id}' type='checkbox' onchange=detectSelectedGame() onClick="setBuildsSelectAllCheckbox()" />`);
                    }
                },
                {
                    sortable: true,
                    data: "GameCode",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnGameCode${rowData.Id}'>${data}</span>`)
                },
                {
                    sortable: false,
                    data: "CustomerOperationCode",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCustomerOperationCode${rowData.Id}'>${rowData.CustomerCode} | ${data}</span>`)
                },
                {
                    sortable: false,
                    data: "GameStatus",
                    render: (data: any, type: any, rowData: any) => {
                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                        var css = data === true ? 'status-enabled' : 'status-disabled';
                        return `<span id='spnGameStatus${rowData.Id}' class='${css}'>${text}</span>`;
                    }
                },
                {
                    sortable: false,
                    data: "ModuleVersion",
                    render: (data: any, type: any, rowData: any) => 
                        (`<span class='buildVersion-format' id='spnModuleVersion${rowData.Id}'>${data}</span>`)
                },
                {
                    sortable: false,
                    render: (data: any, type: any, rowData: any) => {
                        var md5 = "";
                        var sha1 = "";
                        var sha256 = "";
                        if (rowData.Hashes.hasOwnProperty("MD5")) {
                            md5 = rowData.Hashes['MD5'];
                        }
                        if (rowData.Hashes.hasOwnProperty("SHA1")) {
                            sha1 = rowData.Hashes['SHA1'];
                        }
                        if (rowData.Hashes.hasOwnProperty("SHA256")) {
                            sha256 = rowData.Hashes['SHA256'];
                        }
                        return `<span id='spnModuleVersionMd5Hash' name="md5hash" class="hash-format" title="${md5}">${this.shortHash(md5)}</span>
                          <span id='spnModuleVersionSha1Hash' name="sha1hash" class="hash-format" title="${sha1}">${this.shortHash(sha1)}</span>
                          <span id='spnModuleVersionSha256Hash' name="sha256hash" class="hash-format" title="${sha256}">${this.shortHash(sha256)}</span>`;
                    }
                },
                {
                    sortable: false,
                    data: "SelectedModuleVersion",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span class='buildVersion-format' id='spnSelectedModuleVersion${rowData.Id}'>${data}</span>`)
                },
                {
                    sortable: false,
                    render: (data: any, type: any, rowData: any) => {
                        var md5 = "";
                        var sha1 = "";
                        var sha256 = "";
                        if (rowData.SelectedHashes.hasOwnProperty("MD5")) {
                            md5 = rowData.SelectedHashes['MD5'];
                        }
                        if (rowData.SelectedHashes.hasOwnProperty("SHA1")) {
                            sha1 = rowData.SelectedHashes['SHA1'];
                        }
                        if (rowData.SelectedHashes.hasOwnProperty("SHA256")) {
                            sha256 = rowData.SelectedHashes['SHA256'];
                        }
                        return `<span id='spnSelectedModuleVersionMd5Hash' name="md5hash" class="hash-format" title="${md5}">${this.shortHash(md5)}</span>
                          <span id='spnSelectedModuleVersionSha1Hash' name="sha1hash" class="hash-format" title="${sha1}">${this.shortHash(sha1)}</span>
                          <span id='spnSelectedModuleVersionSha256Hash' name="sha256hash" class="hash-format" title="${sha256}">${this.shortHash(sha256)}</span>`;
                    }
                },
                {
                    orderable: false,
                    data: 'filterButtons',
                    defaultContent: '',
                    searchable: false,
                    sortable: false
                }
            ],
            callbacks: {
                drawCallback: this.drawCallback,
                preDrawCallback: this.preDrawCallback
            }
        };
    }

    init(): void {
        this._form = Utils.getJQueryById("formGameBuilConfigurations");
        this._btnCancelSearch = Utils.getJQueryById("btnCancelSearch");
        this._filterGame = new MultiSelectApi('filterGame');
        this._filterOperation = new MultiSelectApi('filterOperation');
        this._filterGameStatus = new MultiSelectApi('filterGameStatus');

        this._btnShowMd5 = Utils.getJQueryById("MD5button");
        this._btnShowMd5.on("click", this.showMd5);

        this._btnShowSha1 = Utils.getJQueryById("SHA1button");
        this._btnShowSha1.on("click", this.showSha1);

        this._btnShowSha256 = Utils.getJQueryById("SHA256button");
        this._btnShowSha256.on("click", this.showSha256);

        this._btnAddToBasketMulti = Utils.getJQueryById("btnAddToBasket");
        this._btnAddToBasketMulti.attr("disabled", 1);
        this._btnAddToBasketMulti.on("click", this.addToBasket);

        this._btnSelectBuild = Utils.getJQueryById("btnSelectBuild");
        this._btnSelectBuild.attr("disabled", 1);
        this._btnSelectBuild.on("click", this.showBuildSelector);

        this._chckAllBuilds = Utils.getJQueryById("buildSelectAll");
        this._chckAllBuilds.on("change", this.checkBoxAll);

        // == create 'new Datatable' instance
        this._table = new Datatable(tableId, this._tableOptions);

        // == attach to events
        // filter form submit -> redraw table
        this._form.on('submit', this.formSubmit);

        // cancel search click -> reset filter row values
        this._btnCancelSearch.on('click', this.cancelSearch);
    }

    private setBuildsSelectAllCheckbox(): void {
        var checkboxes = $("input[name='selectedBuild']");
        let buildSelectAll = Utils.getJQueryById("buildSelectAll")[0];
        if (Utils.isNullOrUndefined(buildSelectAll))
            return;
        let allCheckboxesChecked = false;
        for (var i = 0; i < checkboxes.length; i++) {
            allCheckboxesChecked = (<HTMLInputElement>checkboxes[i]).checked;
            if (!allCheckboxesChecked)
                break;
        }        
        (<HTMLInputElement>buildSelectAll).checked = allCheckboxesChecked;
    }

    private checkBoxAll(): void {
        var checkboxes = $("input[name='selectedBuild']");
        for (var i = 0; i < checkboxes.length; i++) {
            (<HTMLInputElement>checkboxes[i]).checked = (<HTMLInputElement>this._chckAllBuilds[0]).checked;
        }
        this.detectSelectedGame();
    }

    private deselectAll(): void {
        var checkboxes = $("input[name='selectedBuild']");
        for (var i = 0; i < checkboxes.length; i++) {
            (<HTMLInputElement>checkboxes[i]).checked = false;
        }
        this.detectSelectedGame();
    }

    private cancelSearch(e: JQueryEventObject): void {
        this._filterGame.selectAll();
        this._filterOperation.selectAll();
        this._filterGameStatus.selectAll();
    }

    private formSubmit(e: JQueryEventObject): any {
        e.preventDefault();
        this._table.draw();
        return false;
    }

    private showMd5(): void {
        selectedType = "MD5";
        this.displayHash();
    }

    private showSha1(): void {
        selectedType = "SHA1";
        this.displayHash();
    }

    private showSha256(): void {
        selectedType = "SHA256";
        this.displayHash();
    }

    private displayHash(): void {
        hashTypes.forEach(type => {
            $(`span[name='${type.toLowerCase()}hash']`).toggle(selectedType === type);
            $(`#${type}button`).toggleClass("green", selectedType === type);
        });
    }

    private shortHash(hash : string): string {
        if (hash.length > 0) {
            return `${hash.substring(0, 4)}...${hash.substring(hash.length - 4)}`;
        }
        return "";
    }

    private drawCallback(datatable: DatatableApi): any {
        this.showHideSelectAllCheckboxes();
        this.displayHash();
    }

    private preDrawCallback(datatable: DatatableApi): any {
        (<HTMLInputElement>this._chckAllBuilds[0]).checked = false;
        this.showHideSelectAllCheckboxes();
        var filterGame = this._filterGame.isAllSelected() ? '' : this._filterGame.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMN_INDEX.GameCode).search(filterGame);

        var filterCustomerOperation = this._filterOperation.isAllSelected() ? '' : this._filterOperation.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMN_INDEX.Operation).search(filterCustomerOperation);

        var filterGameStatus = this._filterGameStatus.isAllSelected()? '' : this._filterGameStatus.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMN_INDEX.GameStatus).search(filterGameStatus);

        return true;
    }

    private addToBasket(e: JQueryEventObject): void {
        e.preventDefault();
        var urlPost = this._options.urlPost;
        var table = this._table;
        var basketTable = Utils.getJQueryById(basketTableId).DataTable();
        var ids = $("input[name='selectedBuild']:checked").map(function() {
            return $(this).val();
        });
        var idsToAdd = ids.get();
        if (!idsToAdd || idsToAdd.length === 0) {
            return;
        }
        $.ajax({
            url: urlPost,
            type: "POST",
            dataType: 'html',
            data: { ids: idsToAdd },
            success: function(data) {
                table.draw();
                basketTable.draw();
            }
        });
        this.deselectAll();
    }

    private detectSelectedGame(): void {
        var ids = $("input[name='selectedBuild']:checked").map(function() {
            var val: string = $(this).val();
            return val.substring(0, val.indexOf("-"));
        });
        var idsArray = ids.toArray();
        var unique = idsArray.filter((value, index, array) => array.indexOf(value) === index);
        if (idsArray.length > 0) {
            this._btnAddToBasketMulti.removeAttr("disabled");
        } else {
            this._btnAddToBasketMulti.attr("disabled", 1);
        }
        if (unique.length === 1) {
            this._btnSelectBuild.removeAttr("disabled");
            selectedName = unique.join();
        } else {
            this._btnSelectBuild.attr("disabled", 1);
            selectedName = "";
        }
    }

    private showBuildSelector() {
        var buildSelectorTable = Utils.getJQueryById(buildSelectorTableId).DataTable();
        buildSelectorTable.draw();
        $('#buildSelector').removeAttr("hidden");
    }

    private showHideSelectAllCheckbox(selectAllButton: string, checkboxesIdentifier: string): void {
        let selectAllCheckbox = Utils.getJQueryById(selectAllButton)[0];
        if (Utils.isNullOrUndefined(selectAllCheckbox))
            return;
        var checkboxes = $(checkboxesIdentifier);
        if (checkboxes.length === 0) {
            (<HTMLInputElement>selectAllCheckbox).hidden = true;
        } else {
            (<HTMLInputElement>selectAllCheckbox).hidden = false;
        }
    }

    private showHideSelectAllCheckboxes(): void {
        this.showHideSelectAllCheckbox("buildSelectAll", "input[name='selectedBuild']");
    }
}

export class BasketPage extends PageBase<IndexPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;

    private _form: JQuery;
    private _btnCancelSearch: JQuery;
    private _filterGame: MultiSelectApi;
    private _filterOperation: MultiSelectApi;
    private _filterGameStatus: MultiSelectApi;
    private _chckAllBasket: JQuery;

    constructor(options: IndexPageOptions) {
        super(options);

        this.showHash = this.showHash.bind(this);
        this.drawCallback = this.drawCallback.bind(this);
        this.removeFromBasket = this.removeFromBasket.bind(this);
        this.clearBasket = this.clearBasket.bind(this);
        this.formSubmit = this.formSubmit.bind(this);
        this.cancelSearch = this.cancelSearch.bind(this);
        this.preDrawCallback = this.preDrawCallback.bind(this);
        this.checkBoxAll = this.checkBoxAll.bind(this);

        window['setBasketSelectAllCheckbox'] = this.setBasketSelectAllCheckbox;

        // === prepare table options
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Id',
            order: [1, "asc"],
            autoWidth: true,
            pageLength: 100,
            lengthMenu: [[50, 100, 200, 500, 1000], [50, 100, 200, 500, 1000]],
            columns: [
                {
                    sortable: false,
                    render: (data: any, type: any, rowData: any) => {
                        return (`<input id='chckbxBasket${rowData.Id}' name='selectedBasketRow' value='${rowData.Id}' type='checkbox' onClick="setBasketSelectAllCheckbox()" />`);
                    }
                },
                {
                    sortable: true,
                    data: "GameCode",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnBasketGameCode${rowData.Id}'>${data}</span>`)
                },
                {
                    sortable: false,
                    data: "CustomerOperationCode",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnBasketCustomerOperationCode${rowData.Id}'>${rowData.CustomerCode} | ${data}</span>`)
                },
                {
                    sortable: false,
                    data: "GameStatus",
                    render: (data: any, type: any, rowData: any) => {
                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                        var css = data === true ? 'status-enabled' : 'status-disabled';
                        return `<span id='spnBasketGameStatus${rowData.Id}' class='${css}'>${text}</span>`;
                    }
                },
                {
                    sortable: false,
                    data: "SelectedModuleVersion",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span class='buildVersion-format' id='spnBasketSelectedModuleVersion${rowData.Id}'>${data}</span>`)
                },
                {
                    sortable: false,
                    render: (data: any, type: any, rowData: any) => {
                        var md5 = "";
                        var sha1 = "";
                        var sha256 = "";
                        if (rowData.SelectedHashes.hasOwnProperty("MD5")) {
                            md5 = rowData.SelectedHashes['MD5'];
                        }
                        if (rowData.SelectedHashes.hasOwnProperty("SHA1")) {
                            sha1 = rowData.SelectedHashes['SHA1'];
                        }
                        if (rowData.SelectedHashes.hasOwnProperty("SHA256")) {
                            sha256 = rowData.SelectedHashes['SHA256'];
                        }
                        return `<span id='spnBasketSelectedModuleVersionMd5Hash' name="md5hash" class="hash-format" title="${md5}">${this.shortHash(md5)}</span>
                          <span id='spnBasketSelectedModuleVersionSha1Hash' name="sha1hash" class="hash-format" title="${sha1}">${this.shortHash(sha1)}</span>
                          <span id='spnBasketSelectedModuleVersionSha256Hash' name="sha256hash" class="hash-format" title="${sha256}">${this.shortHash(sha256)}</span>`;
                    }
                },
                {
                    orderable: false,
                    data: 'filterButtons',
                    defaultContent: '',
                    searchable: false,
                    sortable: false
                }
            ],
            callbacks: {
                drawCallback: this.drawCallback,
                preDrawCallback: this.preDrawCallback
            }
        };
    }

    init(): void {
        const btnRemoveFromBasketMulti = Utils.getJQueryById("btnRemoveFromBasket");
        btnRemoveFromBasketMulti.on("click", this.removeFromBasket);
        const btnClearBasket = Utils.getJQueryById("btnClearAll");
        btnClearBasket.on("click", this.clearBasket);
        this._form = Utils.getJQueryById("formBasket");
        this._btnCancelSearch = Utils.getJQueryById("btnBasketCancelSearch");
        this._filterGame = new MultiSelectApi('filterBasketGame');
        this._filterOperation = new MultiSelectApi('filterBasketOperation');
        this._filterGameStatus = new MultiSelectApi('filterBasketGameStatus');
        this._chckAllBasket = Utils.getJQueryById("basketSelectAll");
        this._chckAllBasket.on("change", this.checkBoxAll);
        // == create 'new Datatable' instance
        this._table = new Datatable(basketTableId, this._tableOptions);

        // == attach to events
        // filter form submit -> redraw table
        this._form.on('submit', this.formSubmit);

        // cancel search click -> reset filter row values
        this._btnCancelSearch.on('click', this.cancelSearch);
    }

    private setBasketSelectAllCheckbox(): void {
        var checkboxes = $("input[name='selectedBasketRow']");
        let basketSelectAll = Utils.getJQueryById("basketSelectAll")[0];
        if (Utils.isNullOrUndefined(basketSelectAll))
            return;
        let allCheckboxesChecked = false;
        for (var i = 0; i < checkboxes.length; i++) {
            allCheckboxesChecked = (<HTMLInputElement>checkboxes[i]).checked;
            if (!allCheckboxesChecked)
                break;
        }        
        (<HTMLInputElement>basketSelectAll).checked = allCheckboxesChecked;
    }

    private checkBoxAll(): void {
        var checkboxes = $("input[name='selectedBasketRow']");
        for (var i = 0; i < checkboxes.length; i++) {
            (<HTMLInputElement>checkboxes[i]).checked = (<HTMLInputElement>this._chckAllBasket[0]).checked;
        }
    }

    private showHideSelectAllCheckbox(selectAllButton: string, checkboxesIdentifier: string): void {
        let selectAllCheckbox = Utils.getJQueryById(selectAllButton)[0];
        if (Utils.isNullOrUndefined(selectAllCheckbox))
            return;
        var checkboxes = $(checkboxesIdentifier);
        if (checkboxes.length === 0) {
            (<HTMLInputElement>selectAllCheckbox).hidden = true;
        } else {
            (<HTMLInputElement>selectAllCheckbox).hidden = false;
        }
    }

    private showHideSelectAllCheckboxes(): void {
        this.showHideSelectAllCheckbox("basketSelectAll", "input[name='selectedBasketRow']");
    }

    private shortHash(hash : string): string {
        if (hash.length > 0) {
            return `${hash.substring(0, 4)}...${hash.substring(hash.length - 4)}`;
        }
        return "";
    }

    private showHash(): void {
        hashTypes.forEach(type => {
            $(`span[name='${type.toLowerCase()}hash']`).toggle(selectedType === type);
        });
    }

    private drawCallback(datatable: DatatableApi): any {
        this.showHideSelectAllCheckboxes();
        this.showHash();
    }

    private removeFromBasket(e: JQueryEventObject): void {
        e.preventDefault();
        var urlPost = this._options.urlRemove;
        var table = this._table;
        var buildConfigurationTable = Utils.getJQueryById(tableId).DataTable();
        var ids = $("input[name='selectedBasketRow']:checked").map(function() {
            return $(this).val();
        });
        var idsToRemove = ids.get();
        if (!idsToRemove || idsToRemove.length === 0) {
            return;
        }
        $.ajax({
            url: urlPost,
            type: "POST",
            dataType: 'html',
            data: { ids: idsToRemove },
            success: function(data) {
                table.draw();
                buildConfigurationTable.draw();
            }
        });
    }

    private clearBasket(e: JQueryEventObject): void {
        e.preventDefault();
        var urlPost = this._options.urlClear;
        var table = this._table;
        var buildConfigurationTable = Utils.getJQueryById(tableId).DataTable();
        $.ajax({
            url: urlPost,
            type: "POST",
            dataType: 'html',
            success: function(data) {
                table.draw();
                buildConfigurationTable.draw();
            }
        });
    }

    private preDrawCallback(datatable: DatatableApi): any {
        (<HTMLInputElement>this._chckAllBasket[0]).checked = false;
        this.showHideSelectAllCheckboxes();
        var filterGame = this._filterGame.isAllSelected() ? '' : this._filterGame.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMN_INDEX.GameCode).search(filterGame);

        var filterCustomerOperation = this._filterOperation.isAllSelected() ? '' : this._filterOperation.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMN_INDEX.Operation).search(filterCustomerOperation);

        var filterGameStatus = this._filterGameStatus.isAllSelected()? '' : this._filterGameStatus.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMN_INDEX.GameStatus).search(filterGameStatus);

        return true;
    }

    private cancelSearch(e: JQueryEventObject): void {
        this._filterGame.selectAll();
        this._filterOperation.selectAll();
        this._filterGameStatus.selectAll();
    }

    private formSubmit(e: JQueryEventObject): any {
        e.preventDefault();
        this._table.draw();
        return false;
    }
}

export class BuildSelectorPage extends PageBase<IndexPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;
    private _btnSelectBuild: JQuery;
    private _btnAddToBasketMulti: JQuery;

    constructor(options: IndexPageOptions) {
        super(options);

        this.preDrawCallback = this.preDrawCallback.bind(this);
        this.hideSelector = this.hideSelector.bind(this);
        this.selectBuild = this.selectBuild.bind(this);
        window['enableSelectButton'] = this.enableSelectButton;
        // === prepare table options
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'StringVersion',
            autoWidth: true,
            columns: [
                {
                    sortable: false,
                    render: (data: any, type: any, rowData: any) => {
                        return (`<input type='radio' name='selectedVersion' id='spnRadioButton${rowData.StringVersion}' value='${rowData.StringVersion}' onChange=enableSelectButton() />`);
                    }
                },
                {
                    sortable: false,
                    data: "StringVersion",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnStringVersion${rowData.StringVersion}'>${data}</span>`)
                },
                {
                    sortable: false,
                    data: "Hashes",
                    render: (data: any, type: any, rowData: any) => {
                        var md5 = "";
                        var sha1 = "";
                        var sha256 = "";
                        if (data.hasOwnProperty("MD5")) {
                            md5 = data['MD5'];
                        }
                        if (data.hasOwnProperty("SHA1")) {
                            sha1 = data['SHA1'];
                        }
                        if (data.hasOwnProperty("SHA256")) {
                            sha256 = data['SHA256'];
                        }
                        return `<table id='tblStringContent${rowData.StringVersion}' class='buildVersion-table'>
                                <tr><td>MD5: </td><td>${md5}</td></tr>
                                <tr><td>SHA1: </td><td>${sha1}</td></tr>
                                <tr><td>SHA256: </td><td>${sha256}</td></tr>
                                </table>`;
                    }
                },
                {
                    sortable: false,
                    data: "Created",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCreated${rowData.StringVersion}'>${DateUtils.toDefaultWithTime(data)}</span>`)
                },
                {
                    sortable: false,
                    data: "Description",
                    render: (data: any, type: any, rowData: any) => {
                        var description = Utils.isNullOrUndefined(data) ? "" : data;
                        return `<span id='spnDescription${rowData.StringVersion}'>${description}</span>`;
                    }
                },
                {
                    sortable: false,
                    data: "IsEnabled",
                    render: (data: any, type: any, rowData: any) => {
                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                        var css = data === true ? 'status-enabled' : 'status-disabled';
                        return `<span id='spnState${rowData.Id}' class='${css}'>${text}</span>`;
                    }
                },
                {
                    sortable: false,
                    data: "IsValid",
                    render: (data: any, type: any, rowData: any) => {
                        var css = data === true ? 'status-enabled' : 'status-disabled';
                        return `<span id='spnState${rowData.Id}' class='${css}'>${StringUtils.capitalizeFirstLetter(data.toString())}</span>`;
                    }
                }
            ],
            callbacks: {
                preDrawCallback: this.preDrawCallback
            }
        };
    }

    init(): void {
        const btnHideBuildSelector = Utils.getJQueryById("btnHideBuildSelector");
        btnHideBuildSelector.on("click", this.hideSelector);
        const btnSelectVersion = Utils.getJQueryById("btnSelectVersion");
        btnSelectVersion.on("click", this.selectBuild);
        btnSelectVersion.attr("disabled", "disabled");
        this._btnSelectBuild = Utils.getJQueryById("btnSelectBuild");
        this._btnAddToBasketMulti = Utils.getJQueryById("btnAddToBasket");
        this._table = new Datatable(buildSelectorTableId, this._tableOptions);
    }

    private preDrawCallback(datatable: DatatableApi): any {
        datatable.columns(1).search(selectedName);
        
        return true;
    }

    private hideSelector(): void {
        this.disableSelectButton();
        $('#buildSelector').attr("hidden", "hidden");
    }

    private enableSelectButton(): void {
        const selectButton = Utils.getJQueryById("btnSelectVersion");
        selectButton.removeAttr("disabled");
    }

    private disableSelectButton(): void {
        const selectButton = Utils.getJQueryById("btnSelectVersion");
        selectButton.attr("disabled", "disabled");
    }

    private selectBuild(): void {
        var urlPost = this._options.urlPost;
        var buildConfigurationTable = Utils.getJQueryById(tableId).DataTable();
        var basketTable = Utils.getJQueryById(basketTableId).DataTable();
        var ids = $("input[name='selectedBuild']:checked").map(function() {
            return $(this).val();
        });
        var idsToChange = ids.get();
        if (!idsToChange || idsToChange.length === 0) {
            this.hideSelector();
            return;
        }

        var selectedVersion = $("input[name='selectedVersion']:checked").map(function() {
            return $(this).val();
        })
        var versionToSet = selectedVersion.get();
        if (!versionToSet || versionToSet.length === 0) {
            this.hideSelector();
            return;
        }

        $.ajax({
            url: urlPost,
            type: "POST",
            dataType: 'html',
            data: { selectedGame: selectedName, ids: idsToChange, version: versionToSet[0] },
            success: function(data) {
                buildConfigurationTable.draw();
                basketTable.draw();
            }
        });
        this.hideSelector();
        this.deselectAll();
    }

    private deselectAll(): void {
        var checkboxes = $("input[name='selectedBuild']");
        for (var i = 0; i < checkboxes.length; i++) {
            (<HTMLInputElement>checkboxes[i]).checked = false;
        }
        this.detectSelectedGame();
    }

    private detectSelectedGame(): void {
        var ids = $("input[name='selectedBuild']:checked").map(function() {
            var val: string = $(this).val();
            return val.substring(0, val.indexOf("-"));
        });
        var idsArray = ids.toArray();
        var unique = idsArray.filter((value, index, array) => array.indexOf(value) === index);
        if (idsArray.length > 0) {
            this._btnAddToBasketMulti.removeAttr("disabled");
        } else {
            this._btnAddToBasketMulti.attr("disabled", 1);
        }
        if (unique.length === 1) {
            this._btnSelectBuild.removeAttr("disabled");
            selectedName = unique.join();
        }
        else {
            this._btnSelectBuild.attr("disabled", 1);
            selectedName = "";
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/GameBuildConfiguration/IndexPage.ts
 **/